export const selector = {
    heroImage: 'hero-image',
    destinationBreadcrum: 'destination-breadcrumb',
    greatPlacesToStay: 'great-places-to-stay',
    urgencyMessage: 'destination-urgency-message',
    familyFriendly: 'family-inventory',
    recentActivity: 'recent-activity',
    recommendedProperties: 'recommended-properties-',
    propertyTypes: 'property-types',
    reviews: 'property-reviews',
    destinationInfographic: 'destination-infographic',
    destinationInfographicOverview: 'destination-infographic-overview',
    destinationInfographicPricing: 'destination-infographic-pricing',
    textContent: 'seo-text',
    tabbedLinkpile: 'tabbed-linkpile',
    collapsibleLinkpile: 'collapsible-linkpile',
    backToTop: 'back-to-top',
    pointsOfInterest: 'points-of-interest',
    carouselPrev: 'SingleImageCarousel__button-prev',
    carouselNext: 'SingleImageCarousel__button-next',
};
